import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { cloneDeep } from 'lodash'
import { TextField } from '@mui/material'
import { DialogConfirm } from "../../../index"
import { createCnaeRecord, updateCnaeRecord } from "../../../../services/apiKYP"

import styles from './styles'
import { OPERATION_MESSAGES } from "../../../../utils/constants/operations"


const initialState = {
  section: '',
  denomination: '',
  group_name: '',
  group_number: '',
  division_name: '',
  division_number: '',
  class_name: '',
  subclass: '',
  treated_subclass: '',
  subclass_denomination: '',
  classification: '',
  observation: '',
}

const initialErrors = {
  section: false,
  denomination: false,
  group_name: false,
  group_number: false,
  division_name: false,
  division_number: false,
  class_name: false,
  subclass: false,
  treated_subclass: false,
  subclass_denomination: false,
  classification: false,
}

function CnaeForm(props) {
  const { cnae, handleClose, open } = props
  const classes = styles()

  const token = useSelector((state) => state.auth.access_token)
  const isEditMode = cnae !== undefined && cnae !== null

  const [formState, setFormState] = useState(initialState)
  const [formErrors, setFormErrors] = useState(initialErrors)

  const validate = () => {
    const errors = cloneDeep(initialErrors)

    Object.keys(errors).forEach((key) => {
      if (formState[key] === '') errors[key] = true
    })

    if (Object.keys(errors).some((key) => errors[key])) {
      setFormErrors(errors)
      return false
    }

    return true
  }

  const handleSubmit = () => {
    if (!validate()) {
      toast.error(OPERATION_MESSAGES.CHECK_INFORMED_DATA)
      return
    }

    if (isEditMode) {
      updateCnaeRecord(token, formState)
        .then((response) => {
          if (response.status === 204) {
            toast.success(OPERATION_MESSAGES.RECORD_UPDATE_SUCCESS)
            handleClose()
          }
        })
        .catch(() => {
          toast.error(OPERATION_MESSAGES.RECORD_UPDATE_FAIL)
        })
        .finally(() => {
        })
    } else {
      createCnaeRecord(token, formState)
        .then((response) => {
          if (response.status === 201) {
            toast.success(OPERATION_MESSAGES.RECORD_ADD_SUCCESS)
            handleClose()
          }
        })
        .catch(() => {
          toast.error(OPERATION_MESSAGES.RECORD_ADD_FAIL)
        })
        .finally(() => {
        })
    }
  }

  const handleFieldChange = (event) => {
    const key = event.target.id
    const newFormState = cloneDeep(formState)
    newFormState[key] = event.target.value
    setFormState(newFormState)
  }

  const clearAndClose = () => {
    setFormState(initialState)
    setFormErrors(initialErrors)
    handleClose()
  }

  useEffect(() => {
    if (cnae) {
      setFormState(cnae)
    } else {
      setFormState(initialState)
    }
  }, [cnae])

  return (
    <DialogConfirm
      open={open}
      onConfirm={handleSubmit}
      onCancel={clearAndClose}
      fullWidth={true}
      maxWidth='md'
      showCloseButton={true}
      title="CNAE"
      contextText='Informe abaixo, os dados do CNAE.'
    >
      <React.Fragment>
        <TextField
          id="denomination"
          label="Denominação"
          onChange={handleFieldChange}
          value={formState.denomination}
          error={formErrors.denomination}
          size="small"
          required
          margin="dense"
          fullWidth
          variant="standard"
        />

        <div className={classes.row}>
          <TextField
            id="section"
            label="Seção"
            onChange={handleFieldChange}
            value={formState.section}
            error={formErrors.section}
            size="small"
            required
            margin="dense"
            fullWidth
            variant="standard"
          />

          <TextField
            id="classification"
            label="Classificação"
            onChange={handleFieldChange}
            value={formState.classification}
            error={formErrors.classification}
            size="small"
            required
            margin="dense"
            fullWidth
            variant="standard"
          />
        </div>

        <div className={classes.row}>
          <TextField
            id="group_number"
            label="Número do grupo"
            onChange={handleFieldChange}
            value={formState.group_number}
            error={formErrors.group_number}
            size="small"
            type="number"
            required
            margin="dense"
            fullWidth
            variant="standard"
          />

          <TextField
            id="division_number"
            label="Número da divisao"
            onChange={handleFieldChange}
            value={formState.division_number}
            error={formErrors.division_number}
            size="small"
            type="number"
            required
            margin="dense"
            fullWidth
            variant="standard"
          />
        </div>

        <TextField
          id="group_name"
          label="Nome do grupo"
          onChange={handleFieldChange}
          value={formState.group_name}
          error={formErrors.group_name}
          size="small"
          required
          margin="dense"
          fullWidth
          variant="standard"
        />

        <TextField
          id="division_name"
          label="Nome da divisão"
          onChange={handleFieldChange}
          value={formState.division_name}
          error={formErrors.division_name}
          size="small"
          required
          margin="dense"
          fullWidth
          variant="standard"
        />

        <TextField
          id="class_name"
          label="Nome da classe"
          onChange={handleFieldChange}
          value={formState.class_name}
          error={formErrors.class_name}
          size="small"
          required
          margin="dense"
          fullWidth
          variant="standard"
        />

        <div className={classes.row}>
          <TextField
            id="subclass"
            label="Sub-classe"
            onChange={handleFieldChange}
            value={formState.subclass}
            error={formErrors.subclass}
            size="small"
            required
            margin="dense"
            fullWidth
            variant="standard"
          />

          <TextField
            id="treated_subclass"
            label="Sub-classe tratada (apenas numeros)"
            onChange={handleFieldChange}
            value={formState.treated_subclass}
            error={formErrors.treated_subclass}
            size="small"
            type="number"
            required
            margin="dense"
            fullWidth
            variant="standard"
          />
        </div>

        <TextField
          id="subclass_denomination"
          label="Denominação da sub-classe"
          onChange={handleFieldChange}
          value={formState.subclass_denomination}
          error={formErrors.subclass_denomination}
          size="small"
          required
          margin="dense"
          fullWidth
          variant="standard"
        />

        <TextField
          id="observation"
          label="Observação"
          onChange={handleFieldChange}
          value={formState.observation}
          size="small"
          margin="dense"
          fullWidth
          variant="standard"
        />
      </React.Fragment>
    </DialogConfirm>
  )
}

export default CnaeForm
